<!-- eslint-disable prettier/prettier -->
<template>
    <div>
      <b-container fluid>
        <b-row>
          <b-col class="col-lg-12 p-2">
            <b-card>
              <form class="profile-form" @submit.prevent="saveProfile">
                <div class="profile-wrap">
                  <div class="">
                    <div class="picture-profile text-left">
                      <img class="profile-image mb-3" :src="profileimagelink" />
                      <b-button
                        class=""
                        style="width: 200px"
                        variant="outline-success"
                        @click="triggerFileClick()"
                        ><b-icon-image></b-icon-image> Change Logo </b-button
                      >
                      <input
                        type="file"
                        ref="photo"
                        @input="handleImage"
                        class="profile-photo-input"
                      />
  
                      <b-modal
                        id="modal-delete"
                        centered
                        title="Confirm Delete"
                        ok
                        ok-variant="danger"
                        cancel-variant="success"
                        @ok="$bvModal.show('modal-delete2')"
                      >
                        <template v-slot:modal-ok> Delete </template>
                        <p>
                          Are you sure you want to delete account? This operation cannot be
                          reversed!
                        </p>
                      </b-modal>
  
                      <b-modal
                        id="modal-delete2"
                        centered
                        title="Delete? Are you sure?"
                        ok
                        ok-variant="danger"
                        cancel-variant="success"
                        @ok="deleteAccount"
                      >
                        <template v-slot:modal-ok>
                          <b-overlay
                            :show="deletingAccount"
                            rounded
                            opacity="0.6"
                            spinner-small
                            spinner-variant="primary"
                            class=""
                            >Delete</b-overlay
                          >
                        </template>
                        <p>
                          Please be double sure you want to carry out this operation! The
                          operation cannot be reversed!
                        </p>
                      </b-modal>
  
                      <!-- <p @click="$bvModal.show('modal-delete')" class="delete-class">
                        Delete Account
                      </p> -->
                    </div>
                  </div>

                  <div class="text-profile mt-5">
                    
                    <b-form-group class="fo-pro" label="">
                      <div class="row">
                          <b-form-group class="col-lg-6">
                            <p class="secll">Organization Name :</p>
                            <b-form-input placeholder="Organization Name" disabled v-model="org.organization_name">
                            </b-form-input>
                          </b-form-group>
      
                          <b-form-group class="col-lg-6">
                            <p class="secll">Organization Shortname (Domain) :</p>
                            <b-form-input placeholder="Organization Shortname (Domain)" disabled v-model="org.organization_shortname">
                            </b-form-input>
                          </b-form-group>
                      </div>

                      <div class="row">
                          <b-form-group class="col-lg-6">
                            <p class="secll">Contact Email :</p>
                            <b-form-input
                              placeholder="Email"
                              v-model="org.contact_email"
                              type="email"
                            >
                            </b-form-input>
                          </b-form-group>
      
                          <b-form-group class="col-lg-6">
                            <p class="secll">Contact Phone :</p>
                            <div class="form-input-2">
                              <vue-phone-number-input :show-code-on-list="true" :fetch-country="true" :no-example="true" size="sm" v-model="org.contact_phone" />
                            </div>
                          </b-form-group>
                      </div>

                      <div class="row">
                          <b-form-group class="col-lg-6">
                            <p class="secll">Address :</p>
                            <b-form-input placeholder="Adress" v-model="org.address" type="text">
                            </b-form-input>
                          </b-form-group>
      
                          <b-form-group class="col-lg-6">
                            <p class="secll">City :</p>
                            <b-form-input placeholder="City" v-model="org.city" type="text">
                            </b-form-input>
                          </b-form-group>
                      </div>

                      <div class="row">
                          <b-form-group class="col-lg-6">
                            <p class="secll">State :</p>
                            <b-form-input placeholder="State" v-model="org.state" type="text">
                            </b-form-input>
                          </b-form-group>
      
                          <b-form-group class="col-lg-6">
                            <p class="secll">Country :</p>
                            <b-form-input placeholder="Country" v-model="org.country" type="text">
                            </b-form-input>
                          </b-form-group>
                      </div>

                      <div class="row">
                          <b-form-group class="col-lg-6">
                            <p class="secll">Industry :</p>
                            <b-form-input placeholder="Industry" v-model="org.industry" type="text">
                            </b-form-input>
                          </b-form-group>
      
                          <b-form-group class="col-lg-6">
                            <p class="secll">Date Joined :</p>
                            <b-form-input placeholder="" :disabled="true" v-model="$store.state.loginmaster.details.org_details.created_date" type="text">
                            </b-form-input>
                          </b-form-group>
                      </div>

                      <div class="row">
                        <b-form-group class="col-lg-12">
                          <p class="secll">Organization Description :</p>
                          <b-form-textarea placeholder="Tell us more about the Organization" rows="4" v-model="org.description" type="text">
                          </b-form-textarea>
                        </b-form-group>
                    </div>

                    </b-form-group>  
  
                    <div class="text-center mt-5">
                      <b-button-group>
                        <b-button
                          class="v-button p-lg-2 mr-2"
                          @click="discardChanges()"
                          variant="success"
                          size="xs"
                        >
                          <b-overlay
                            :show="discarding"
                            rounded
                            opacity="0.6"
                            spinner-small
                            spinner-variant="primary"
                            class=""
                            >Discard Changes</b-overlay
                          >
                        </b-button>
  
                        <b-button
                          :disabled="saving"
                          type="submit"
                          class="v-button2 p-lg-2 ml-2"
                          variant="success"
                        >
                          <b-overlay
                            :show="saving"
                            rounded
                            opacity="0.6"
                            spinner-small
                            spinner-variant="primary"
                            class=""
                            >Save Changes</b-overlay
                          >
                        </b-button>
                      </b-button-group>
                    </div>
                  </div>
                  
                </div>
              </form>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";

export default {
  mounted() {
    // this.setImageDirectory("profileimages")

    this.setCurrentModule("Profile");
    //Update the User Object with initial values from the Details on last logged in.

    (this.profileimagelink = this.$store.state.loginmaster.details.org_details.logo),
      (this.org = {
        organization_name: this.$store.state.loginmaster.details.org_details
          .organization_name,
          organization_id: this.$store.state.loginmaster.details.org_details
          .track_id,
        organization_shortname: this.$store.state.loginmaster.details
          .org_details.organization_shortname,
          organization_description: this.$store.state.loginmaster.details
          .org_details.organization_description,
        contact_email: this.$store.state.loginmaster.details.org_details
          .contact_email,
        contact_phone: this.$store.state.loginmaster.details.org_details
          .contact_phone,
        state: this.$store.state.loginmaster.details.org_details.state,
        city: this.$store.state.loginmaster.details.org_details.city,
        country: this.$store.state.loginmaster.details.org_details.country,
        address: this.$store.state.loginmaster.details.org_details.address,
        industry: this.$store.state.loginmaster.details.org_details.industry,
        logo: this.$store.state.loginmaster.details.org_details.logo
      });
  },

  data() {
    return {
      saving: false,
      org: this.getForm(),
      instiarr: [],
      profileimagelink: "",
      uploadingprofileimage: false,
      discarding: false,
      showcopy: false,
      showcopy2: false,
      deletingAccount: false,
      activeTab: "UserProfile"
    };
  },
  methods: {
    ...mapActions("dashboard", ["saveUserProfile"]),
    ...mapActions("admin", ["setCurrentModule"]),
    ...mapActions("loginmaster", [
      "updateDetails",
      "deleteUserAccount",
      "logOut",
      "saveOrgProfile"
    ]),
    triggerFileClick() {
      this.$refs.photo.click();
    },
    // Get the Contents of the Submitted form in an Object
    getForm() {
      return {
        organization_name: this.$store.state.loginmaster.details.org_details
          .organization_name,
        organization_id: this.$store.state.loginmaster.details.org_details
          .track_id,
        organization_shortname: this.$store.state.loginmaster.details
          .org_details.organization_shortname,
          organization_description: this.$store.state.loginmaster.details
          .org_details.organization_description,
        contact_email: this.$store.state.loginmaster.details.org_details
          .contact_email,
        contact_phone: this.$store.state.loginmaster.details.org_details
          .contact_phone,
        state: this.$store.state.loginmaster.details.org_details.state,
        city: this.$store.state.loginmaster.details.org_details.city,
        country: this.$store.state.loginmaster.details.org_details.country,
        address: this.$store.state.loginmaster.details.org_details.address,
        industry: this.$store.state.loginmaster.details.org_details.industry,
        logo: this.$store.state.loginmaster.details.org_details.logo
      };
    },

    deleteAccount() {
      this.deletingAccount = true;

      this.deleteUserAccount().then(() => {
        this.deletingAccount = false;

        this.logOut().then(() => {
          this.$router.push({
            name: "login"
          });
        });
      });
    },

    discardChanges() {
      (this.profileimagelink = this.$store.state.loginmaster.details.logo),
        (this.org = {
          organization_name: this.$store.state.loginmaster.details.org_details
            .organization_name,
          organization_id: this.$store.state.loginmaster.details.org_details
            .track_id,
          organization_shortname: this.$store.state.loginmaster.details
            .org_details.organization_shortname,
            organization_description: this.$store.state.loginmaster.details
          .org_details.organization_description,
          contact_email: this.$store.state.loginmaster.details.org_details
            .contact_email,
          contact_phone: this.$store.state.loginmaster.details.org_details
            .contact_phone,
          state: this.$store.state.loginmaster.details.org_details.state,
          city: this.$store.state.loginmaster.details.org_details.city,
          country: this.$store.state.loginmaster.details.org_details.country,
          address: this.$store.state.loginmaster.details.org_details.address,
          industry: this.$store.state.loginmaster.details.org_details.industry,
          logo: this.$store.state.loginmaster.details.org_details.logo
        });
      // this.org.fname = this.orgdet.fname
      // this.org.lname = this.orgdet.lname
      // this.org.email = this.orgdet.email
      // this.org.phone = this.orgdet.phone
      // this.org.city = this.orgdet.city
      // this.org.state = this.orgdet.state
    },

    handleImage() {
      this.uploadingprofileimage = true;
      let profileimage = this.$refs.photo.files[0];
      let formData = new FormData();
      formData.append("image", profileimage);
      formData.append("environment", this.environ);
      formData.append("origin", this.origin);
      formData.append("pretag", "profileimage");
      let apilink = `${this.api_origin}/ImageHandler.php`;

      axios
        .post(apilink, formData, {
          header: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          this.uploadingprofileimage = false;
          this.$bvModal
            .msgBoxOk("Image Uploaded Successfully.", {
              title: "Image Uploaded",
              size: "xs",
              centered: true
            })
            .then(() => {});
          // console.log(response.data);
          //this.setFile(response.data.url);
          this.profileimagelink = response.data.url;
          this.org.logo = response.data.url;
        })
        .catch(() => {
          this.$bvModal
            .msgBoxOk(
              "Check your Network Connection. Could not upload Image.",
              {
                title: "No Network Connection",
                size: "xs",
                centered: true
              }
            )
            .then(() => {
              this.uploadingprofileimage = false;
            });
          //console.log(error);
        });
    },

    saveProfile() {
      this.saving = true; // Update the saving status to true. This triggers on the roller overlay over the button and disables the button.

      // Call the saveUserProfile from the Store's action and pass the org object to it
      return this.saveOrgProfile(this.org).then(() => {
        // After the request has been made and a response received. change the saving status to false to release the button and trigger off the roller.
        this.saving = false;
        this.updateDetails();

        // Send a Modal alert telling the User that the Profile has been saved Successfully.
        this.$bvModal
          .msgBoxOk("Your Profile has been updated Successfully.", {
            title: "Profile Updated",
            size: "xs",
            centered: true
          })
          .then(() => {});
      });
    },
    copylink() {
      navigator.clipboard.writeText(
        `${this.origin}/signup/?ref=${this.$store.state.loginmaster.details.refcode}`
      );
      this.showcopy = true;
    },
    copylink2() {
      navigator.clipboard.writeText(
        `${this.$store.state.loginmaster.details.refcode}`
      );
      this.showcopy2 = true;
    }
  },
  computed: {
    ...mapState({
      orgdet: state => state.loginmaster.details,
      plan: state => state.loginmaster.details.plan,
      premium: state => state.loginmaster.details.premium_details,
      allinsti: state => state.admin.listinstitutions,
      environ: state => state.loginmaster.environ,
      origin: state => state.loginmaster.site_origin,
      api_origin: state => state.loginmaster.api_origin
    })
  }
};
</script>

<style scoped>
.fo-pro {
  width: 100%;
}

.secll {
  font-weight: bold;
  font-size: 1.1rem;
}

.profile-wrap {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}
.text-profile {
  width: 100%;
}
.picture-profile {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  width: 100%;
}

.profile-image {
  width: 200px;
  height: 200px;
  display: inline-block;
  border-radius: 10px 10px;
}
.profile-photo-input {
  font-size: 2rem;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  border: 0px;
  border-radius: 0px;
  height: 10rem;
  display: none;
}

.v-button {
  border-radius: 10px 10px;
  height: 3rem;
  width: 10rem;
  background-color: white;
  font-weight: bolder;
  color: black;
  position: relative;
  bottom: -80%;
  border: 1px solid #00984a;
  font-size: 14px;
}
.v-button:hover {
  background-color: white;
  color: #00984a;
  border: 1px solid #00984a;
}

.v-button2 {
  border-radius: 10px 10px;
  height: 3rem;
  width: 10rem;
  background-color: #00984a;
  font-weight: bolder;
  color: white;
  position: relative;
  bottom: -80%;
  border: 0px;
  font-size: 14px;
}
.v-button2:hover {
  background-color: white;
  color: #00984a;
  border: 1px solid #00984a;
}
.copyinline {
  background-color: #000000;
  color: white;
  display: inline-flex;
  overflow: auto;
  scrollbar-width: thin;
  border-radius: 10px 10px;
}

.copyicon {
  width: 10%;
  cursor: pointer;
  left: -100px;
}

.copytext {
  width: 90%;
  overflow: auto;
  scrollbar-width: thin;
}

.copier {
  position: absolute;
  left: -9999px;
}
.copied {
  position: relative;
  left: -10px;
  font-size: 0.7rem;
}

.delete-class {
  color: red;
  margin-top: 50px;
  cursor: pointer;
  font-size: 24px;
}

.tab-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding-bottom: 10px;
}

.tab-item {
  font-size: 18px;
  padding-bottom: 10px;
  cursor: pointer;
  font-weight: bold;
}

.tab-item-active {
  border-bottom: 3px solid #243057;
}

@media screen and (max-width: 999px) {
  .fo-pro {
    width: 100%;
    margin-left: 0px;
  }
  .picture-profile {
    width: 100%;
  }
  .text-profile {
    width: 100%;
  }
  .v-button {
    font-size: 0.8rem;
  }
  .v-button2 {
    font-size: 0.8rem;
  }
}
</style>
